import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  constructor(private httpClient:HttpClient) { }
  
  public getAttachments( oppId : any) {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<any[]>('/api/v1/opportunity/attachment/for/'+ oppId , {headers});
    //.pipe(catchError(this.errorHandler));
  }

  public countAttachments( oppId : any) {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<any[]>('/api/v1/opportunity/attachment/count/for/'+ oppId , {headers});
  }

  public postAttachment( file: FileAttachment){

    var fd = new FormData(); 
    fd.append( 'attachmentId', file.attachmentId );					
    fd.append( 'attachmentName', file.attachmentName );
    fd.append( 'content', file.content );
    fd.append( 'contentType', file.contentType );
    fd.append( 'created', file.created );
    fd.append( 'opportunity', file.opportunityAttachment.opportunityId+"");
    fd.append( 'userEmail', sessionStorage.getItem("loginUserName") );

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    /*const headers2 = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth') ,
    'Accept' : "multipart/form-data" });*/
    return this.httpClient.post<any>('/api/v1/opportunity/attachment/' , fd , {headers}).pipe(catchError(this.errorHandler));
  }

  public deleteAttachment( oppId: any, attachmentId : any){
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    /*const headers2 = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth') ,
    'Accept' : "multipart/form-data" });*/
    // console.log("inside postattachment");
    // console.log(headers);
    
    let userEmail = sessionStorage.getItem('loginUserName');
    return this.httpClient.delete<any>('/api/v1/opportunity/attachment/' + userEmail +"/"+ oppId + "/" + attachmentId, {headers}).pipe(catchError(this.errorHandler));

  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }

  saveFile (name, type, data) {
    const linkSource = `data:${type};base64,${data}`;
    const downloadLink = document.createElement("a");
    const fileName = name;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}
  
}
export interface FileAttachment{
  attachmentId: string,
  attachmentName : string,
  content : any,
  contentType : string,
  created : string,
  userEmail: string,
  opportunityAttachment: {opportunityId : number}
}


